import * as React from 'react';

import type { Testimonial } from '@coursera-web/cds-labs';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { getSuccessPercentage } from 'bundles/coursera-plus-common/utils/courseraPlusUtils';
import type { PeopleSection } from 'bundles/coursera-plus-landing-page/types/PeopleProfile';

import learnerAbigail from 'images/coursera-plus/learner+-+abigail.png';
import learnerInes from 'images/coursera-plus/learner+-+ines.png';
import learnerShi from 'images/coursera-plus/learner+-+shi.png';

import _t from 'i18n!nls/coursera-plus-landing-page';

export const getTestimonialsRedesign = (): Testimonial[] => [
  {
    id: '1',
    image: {
      url: learnerAbigail,
    },
    authorName: 'Abigail P.',
    quote: _t(
      'I have a full-time job and 3 kids. I needed the flexibility offered by Coursera Plus in order to achieve my goals. My Coursera Plus subscription motivated me to keep learning.'
    ),
  },
  {
    id: '2',
    image: {
      url: learnerShi,
    },
    authorName: 'Shi Jie F.',
    quote: _t(
      // eslint-disable-next-line no-restricted-syntax
      'Coursera Plus keeps me motivated to learn. With each course, I’m getting more value out of my subscription. I can access almost anything with Coursera Plus!'
    ),
  },
  {
    id: '3',
    image: {
      url: learnerInes,
    },
    authorName: 'Inés K.',
    quote: _t(
      // eslint-disable-next-line no-restricted-syntax
      'I really appreciate the flexibility I get with Coursera Plus. I can try any course and switch to another one for no additional cost. This motivates me to learn even more!'
    ),
  },
];

export const getLearnersOutcomeSurveySectionData = (): PeopleSection => {
  const profiles = [
    {
      profileImageUrl: `${learnerAbigail}`,
      name: 'Abigail P.',
      location: 'United States',
      testimonial: (
        <FormattedMessage
          message={_t(
            "I have a full-time job and 3 kids. {iNeededTheFlexibilityOfferedByCourseraPlus} I learned business statistics and analysis to apply to my job, but my Coursera Plus subscription motivated me to keep learning. I have a new career goal to pivot into data analysis and data science. I'm learning Python now!"
          )}
          iNeededTheFlexibilityOfferedByCourseraPlus={
            <strong>{_t('I needed the flexibility offered by Coursera Plus in order to achieve my goals.')}</strong>
          }
        />
      ),
    },
    {
      profileImageUrl: `${learnerShi}`,
      name: 'Shi Jie F.',
      location: 'Singapore',
      testimonial: (
        <FormattedMessage
          message={_t(
            'Coursera Plus keeps me motivated to learn. {gettingMoreValueOutOfMySubscription} I can focus on life sciences—my main specialty—but also pursue other interests like society and religion. I can access almost anything with Coursera Plus!'
          )}
          gettingMoreValueOutOfMySubscription={
            <strong>{_t("With each course, I'm getting more value out of my subscription.")}</strong>
          }
        />
      ),
    },
    {
      profileImageUrl: `${learnerInes}`,
      name: 'Inés K.',
      location: 'France',
      testimonial: (
        <FormattedMessage
          message={_t(
            'I really appreciate the flexibility I get with Coursera Plus. {iCanTryAnyCourseAndSwitchToAnother} This motivates me to learn even more—at one point I was taking three courses at the same time!'
          )}
          iCanTryAnyCourseAndSwitchToAnother={
            <strong>{_t('I can try any course and switch to another one for no additional cost.')}</strong>
          }
        />
      ),
    },
  ];

  const percentage = getSuccessPercentage();
  const subtitle = _t(
    '{percentage} of learners report career benefits, like landing a new job, earning a promotion, gaining applicable skills, and more.'
  );

  return {
    title: _t('Join thousands of Coursera Plus learners achieving their goals'),
    subtitle: <FormattedMessage message={subtitle} percentage={percentage} />,
    source: _t('Source: Coursera Learner Outcomes Survey 2023'),
    profiles,
  };
};
